/** Identidad legal pública (D&B / Apple / Cámara de Comercio). */
export const LEGAL_ENTITY = {
  legalName: "Goldia S A S",
  legalNameFormal: "GOLDIA S.A.S.",
  tradeName: "Gold Loterías",
  nit: "901.010.821-1",
  address: "Diagonal 75 B # 8-40, Oficina 221, Medellín, Antioquia, Colombia",
  website: "https://goldloterias.com",
  workEmail: "gerente@goldloterias.com",
  supportEmail: "soporte@goldloterias.com",
};

export function getLegalOperatorLine() {
  return `${LEGAL_ENTITY.tradeName} es operado por ${LEGAL_ENTITY.legalName}. NIT ${LEGAL_ENTITY.nit}.`;
}

export function getLegalCopyrightLine(year) {
  return `© ${year} ${LEGAL_ENTITY.legalName}. Nombre comercial: ${LEGAL_ENTITY.tradeName}. NIT ${LEGAL_ENTITY.nit}. Todos los derechos reservados.`;
}
